import { EAddedAdsType } from '../../../types/addedAdsType';
export function preparePlacesOffers(formValue) {
  if (!formValue.addedAds) {
    return undefined;
  }
  switch (formValue.addedAds) {
    case EAddedAdsType.No:
      return false;
  }
  return true;
}